import { useEffect, useState } from 'react'
import { datadogRum } from '@datadog/browser-rum'

export const useUrlErrorTracking = (environment: string, error: Error) => {
  const [retryUrl, setRetryUrl] = useState<string>('/')

  useEffect(() => {
    const { pathname } = window.location
    setRetryUrl(pathname)

    if (environment !== 'local') {
      datadogRum.addError(new Error(error.message), {
        error: {
          message: 'User shown error boundary',
          name: error.name,
          stack: error.stack,
        },
        route: pathname,
      })
    }
  }, [error.message, error.name, error.stack])

  return retryUrl
}

export default useUrlErrorTracking
